import { Modal } from "react-bootstrap";

const spinCss = `@keyframes pdf-spin { to { transform: rotate(360deg); } }`;

const PDFModal = ({ showSpinner, setShowSpinner }) => {
  return (
    <Modal show={showSpinner} onHide={() => {}} centered backdrop="static" keyboard={false}>
      <style>{spinCss}</style>
      <Modal.Body style={{ padding: "40px 32px", textAlign: "center" }}>
        {/* Animated ring */}
        <div style={{ position: "relative", width: "64px", height: "64px", margin: "0 auto 24px" }}>
          <div style={{
            position: "absolute", inset: 0,
            border: "4px solid #e8f0fe",
            borderTopColor: "#1a73e8",
            borderRadius: "50%",
            animation: "pdf-spin 0.9s linear infinite",
          }} />
          {/* PDF icon in center */}
          <div style={{
            position: "absolute", inset: 0,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: "18px", fontWeight: 700, color: "#1a73e8", letterSpacing: "-0.5px",
          }}>
            PDF
          </div>
        </div>

        <div style={{ fontWeight: 700, fontSize: "1rem", color: "#212121", marginBottom: "6px" }}>
          Generating PDF
        </div>
        <div style={{ fontSize: "0.82rem", color: "#9e9e9e" }}>
          This might take a moment…
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PDFModal;
